module.exports = __webpack_public_path__ + "img/ro_tip_ico.f8288cf9.png";